var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("x-grid", {
        ref: "grid",
        attrs: {
          id: "childGrid",
          columns: _vm.columns,
          "toolbar-config": _vm.toolbarConfig,
          editable: true,
          "edit-rules": _vm.editRules,
          editConfig: _vm.editConfig,
          cellClick: _vm.chooseRow,
        },
        on: { "edit-closed": _vm.editClosedEvent },
        scopedSlots: _vm._u(
          [
            {
              key: _vm.toolbarConfig.templatelSlots,
              fn: function () {
                return [
                  _c("vxe-button", { on: { click: _vm.add } }, [
                    _vm._v("新增"),
                  ]),
                  _c(
                    "vxe-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.delRow()
                        },
                      },
                    },
                    [_vm._v("删除")]
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }